/* Festive Sale 2026 tote bar (snippets/mm-sale-cart-bar.liquid). Reads window.MMSale (snippets/mm-sale-core.liquid).
   The drawer redraws on every tote change and puts a fresh <mm-sale-cart-bar> in, so all work happens on connect.
   One shared one-second tick drives every countdown on the page. Layout: countdown, what this tote saves now, and a
   timeline with the three parts of the sale as stops, so waiting visibly costs money (owner, 14 Oct 2026). */
(function () {
  if (customElements.get('mm-sale-cart-bar')) return;

  var clocks = new Set();
  var timer = null;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function left(ms) {
    if (ms < 0) ms = 0;
    var s = Math.floor(ms / 1000), d = Math.floor(s / 86400);
    s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    return (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  function tick() {
    var sale = window.MMSale;
    clocks.forEach(function (el) {
      if (!el.isConnected) { clocks.delete(el); return; }
      el.textContent = left(sale.phase.endMs - sale.now());
    });
    if (!clocks.size) { clearInterval(timer); timer = null; }
  }
  function watch(el) {
    clocks.add(el);
    tick();
    if (!timer) timer = setInterval(tick, 1000);
  }
  window.MMSaleClock = { watch: watch, left: left };

  var WHEN = { 1: '15 to 18 Oct', 2: '23 to 25 Oct', 3: '30 Oct to 2 Nov' };
  var FROM = { 1: '15 Oct', 2: '23 Oct', 3: '30 Oct' };

  class MMSaleCartBar extends HTMLElement {
    connectedCallback() {
      var sale = window.MMSale;
      if (!sale || !sale.on || !sale.phase) { this.remove(); return; }
      var money = sale.money;
      // every amount is rounded to whole rupees first, so the parts always add up to the totals shown
      var R = function (paise) { return Math.round(paise / 100) * 100; };
      var base = Number(this.dataset.base) || 0;
      var off = R(Number(this.dataset.off) || base * sale.pct / 100);
      var paid = Math.max(0, base - off);
      var now = sale.phase.n;
      var empty = base <= 0;
      var rows = sale.phases.map(function (p) {
        var credit = R(paid * p.credit / 100);
        return { n: p.n, credit: credit, save: off + credit, pct: sale.pct + p.credit, creditPct: p.credit };
      });
      var cur = rows[now - 1];

      this.querySelector('[data-mm-scb-label]').textContent = cur.creditPct ? cur.creditPct + '% additional credit ends in' : 'Festive Sale ends in';
      var save = this.querySelector('[data-mm-scb-save]'), parts = this.querySelector('[data-mm-scb-parts]');
      if (empty) {
        save.textContent = sale.pct + '% off' + (cur.creditPct ? ' + ' + cur.creditPct + '% back' : '');
        parts.textContent = cur.creditPct ? 'as additional store credit' : 'on everything';
      } else {
        save.textContent = 'You save ' + money(cur.save);
        parts.textContent = money(off) + ' off' + (cur.credit ? ' + ' + money(cur.credit) + ' additional store credit' : '');
      }

      var line = this.querySelector('[data-mm-scb-line]');
      line.style.setProperty('--mm-scb-fill', (now - 1) * 50 + '%');
      line.innerHTML = rows.map(function (r) {
        var cls = r.n === now ? ' is-now' : (r.n < now ? ' is-past' : '');
        var label = r.n === now ? 'Now' : (r.n < now ? 'Ended' : 'From ' + FROM[r.n]);
        var amount = empty ? r.pct + '%' : money(r.save);
        return '<li class="mm-scb__stop' + cls + '"' + (r.n === now ? ' aria-current="step"' : '') + ' title="' + WHEN[r.n] + '">' +
          '<b>' + amount + '</b>' + label + '</li>';
      }).join('');

      var pre = this.querySelector('[data-mm-scb-pre]');
      pre.textContent = '+ ' + (empty ? sale.prepaidPct + '%' : money(R(paid * sale.prepaidPct / 100))) + ' off your next order when you pay online' +
        (this.dataset.codeOn !== 'true' && !empty ? '. Code ' + sale.code + ' applies at checkout.' : '');
      this.hidden = false;
      watch(this.querySelector('[data-mm-scb-clock]'));
    }
  }
  customElements.define('mm-sale-cart-bar', MMSaleCartBar);
})();
